export const uploadPath = "<path d=\"M8 10 V2.5 M5 5.5 L8 2.5 L11 5.5 M3.5 13 H12.5\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>"
